import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { WindowRef } from "@obg/ngx.global";

import { IosNativeBlockConfigService } from "./ios-native-block.config";

@Component({
	templateUrl: "./ios-native-block.component.html",
	styleUrls: ["./ios-native-block.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IosNativeBlockComponent {
	@HostBinding("class.obg-ios-native-block") hostCssClass = true;

	openSiteInBrowserDeeplink: string | undefined;

	constructor(
		private windowRef: WindowRef,
		private config: IosNativeBlockConfigService
	) {
		this.openSiteInBrowserDeeplink = this.config.getOpenSiteInBrowserDeeplink();
	}

	openSiteInBrowser(event: Event) {
		event.preventDefault();

		if (this.openSiteInBrowserDeeplink) {
			this.windowRef.native.location.href = this.openSiteInBrowserDeeplink;
		}
	}
}
